import { getWithAuthn } from "../RequestHelpers";
export var lookupAddress = function (address, country, selected) {
    var params = new URLSearchParams({ address: address, country: country });
    if (selected) {
        params.set("selected", selected);
    }
    return getWithAuthn("/user/lookup-address?" + params.toString()).then(function (response) {
        if (!response.ok) {
            throw new Error("Address lookup " + response.status);
        }
        return response.json();
    }).then(function (json) { return (Array.isArray(json) ? json : [])
        .filter(function (candidate) { return Boolean(candidate) && String(candidate.street || "").trim() !== ""; }); });
};
export var addressCandidateStreetLine = function (candidate) {
    return [candidate.street, candidate.secondary].filter(Boolean).join(" ");
};
export var addressCandidateDescription = function (candidate) {
    var unitOptions = candidate.entries > 0 ? candidate.entries + " unit options" : "";
    var location = [candidate.city, candidate.state, candidate.zipCode].filter(Boolean).join(", ");
    return [unitOptions, location].filter(Boolean).join(" · ");
};
//# sourceMappingURL=AddressLookup.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/Registration/AddressLookup.js
// module id = 1386
// module chunks = 0